export default __webpack_public_path__ + "static/media/bnr8.8bc1cee0.jpg";